/*
 * © 2026 eggs unimedia GmbH
 * Coded with love 💛
 */

import React from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { Icon } from '../../index'
import { useUser } from '../../../hooks/useUser'

function Footer() {
  const { isLoggedIn } = useUser()
  const navigate = useNavigate()

  return (
    <footer className="fixed bottom-0 left-0 right-0 bg-gray-50 border-t border-gray-200 p-4">
      <div className="flex flex-col sm:flex-row flex-wrap justify-center sm:justify-between items-center px-4 gap-3 sm:gap-2">
        <div className="flex justify-center sm:justify-start space-x-6 text-sm">
          <NavLink
            to="/datenschutz"
            className="text-gray-600 hover:text-eggs-yellow transition-colors"
          >
            Datenschutz
          </NavLink>
          <NavLink
            to="/impressum"
            className="text-gray-600 hover:text-eggs-yellow transition-colors"
          >
            Impressum
          </NavLink>
          <a
            href="https://eggsunimedia.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-600 hover:text-eggs-yellow transition-colors"
          >
            ©&nbsp;eggs&nbsp;unimedia
          </a>
        </div>
        
        {!isLoggedIn && (
          <button
            onClick={() => navigate('/login')}
            className="w-full sm:w-auto text-sm text-gray-700 hover:text-primary-dark flex items-center justify-center sm:justify-start space-x-1 font-medium"
          >
            <Icon name="lock" size={14} />
            <span>Anmelden für mehr Features</span>
          </button>
        )}
      </div>
    </footer>
  )
}

export default Footer
